<div>
<fieldset *ngIf="genes.length != 0" class="genes-table">
  <legend>
    {{legend}}
  </legend>

  <div class="description">
    <span class="description-prefix" *ngIf="showingQuilt()">QuiLT visualisation of: </span>
    <span class="description-prefix" *ngIf="showingGeneEx()">Gene expression of: </span>
    <span class="description-prefix" *ngIf="!showingQuilt() && !showingGeneEx()">Query:</span>
    <app-description-display *ngIf="description || descriptionParts.length != 0"
                             [description]="description" [descriptionParts]="descriptionParts">
    </app-description-display>


  <div *ngIf="showingQuilt()" class="documentation-link">
    <div>
      A graphical summary of the genes in your result set
    </div>
    <div>
      <a routerLink="/documentation/quick-little-tool"><img src="/assets/info_icon.svg">Documentation</a>
    </div>
  </div>


  </div>


  <div class="genes-in-gocams-link" *ngIf="showingSubsetCounts() && subsetCountName">
    <ul>
      <li>
        <a (click)="gotoGenesInGoCamQuery('in_gocam')"
           title='View genes from "{{description || "query"}}" that are in one or more pathways'>
          Genes from list in a curated GO-CAM pathway ({{getGenesInGoCamsQueryCount('in_gocam') | async}})
        </a>
      </li>
      <li>
        <a (click)="gotoGenesInGoCamQuery('has_process_not_in_gocam')"
           title='View genes from "{{description || "query"}}" that are not yet included in a pathway that have an annotation biological process'>
          Genes with a biological process but not yet in GO-CAM pathway ({{getGenesInGoCamsQueryCount('has_process_not_in_gocam') | async}})
        </a>

        <span class="bp-slim-query">
          alternatively:
          <a (click)="gotoBPSlimGenesNotInPathway()">
            classify this list with the "Biological process slim"
          </a>
        </span>
      </li>
      <li>
        <a (click)="gotoGenesInGoCamQuery('no_process_not_in_gocam')"
           title='View genes from "{{description || "query"}}" that are not yet included in a pathway'>
          Genes without a biological process (unknowns) ({{getGenesInGoCamsQueryCount('no_process_not_in_gocam') | async}})
        </a>

      </li>
    </ul>
  </div>

  <div class="action-row">
    <div *ngIf="!showingVisualisation() && !showingSlim() && !showingSubsetCounts()">
      <div *ngIf="selectionInProgress()">
  <div class="action">
    <button class="btn btn-primary"
            [disabled]="selectedCount() == 0"
            title="{{selectedCount() == 0 ? 'Select some genes to filter' : 'Filter list to show only the selected genes'}}"
            (click)="filter()">Filter</button>
  </div>

  <div class="action">
    <button class="btn btn-primary"
            title="Cancel gene selection mode"
            (click)="cancelSelection()">Cancel</button>
  </div>

  <div class="action">
    Select: <a (click)="selectAll()">all</a> | <a (click)="selectNone()">none</a>
  </div>
  </div>

  <div *ngIf="!selectionInProgress()">
    <div class="action">
      <button class="btn btn-primary"
              (click)="configureColumns()"
              title="Add/remove columns">
        <fa-icon [icon]="faCog"></fa-icon> Columns ...
      </button>
    </div>

  <div class="btn-group" dropdown *ngIf="slimNames.length != 0">
    <button id="slim-button" dropdownToggle type="button" class="btn btn-primary dropdown-toggle">
      Visualise:
    </button>

    <ul id="vis-dropdown" *dropdownMenu class="dropdown-menu" role="menu">
      <li role="menuitem">
        <a class="dropdown-item" title="Show gene visualisation" (click)="showQuilt()">
          QuiLT
        </a>
      </li>
      <li *ngIf="showGeneExpressionLink">
        <a *ngIf="genes.length <= maxGeneExpressionPlotGenes" class="dropdown-item" title="Show gene visualisation" (click)="showGeneEx()">
          Gene expression (up to {{maxGeneExpressionPlotGenes}} genes)
        </a>
        <a *ngIf="genes.length > maxGeneExpressionPlotGenes" class="dropdown-item disabled-menu-item"
              title="Gene expression visualisation disabled due to too many (>{{maxGeneExpressionPlotGenes}}) genes">
          Gene expression (up to {{maxGeneExpressionPlotGenes}} genes)
        </a>
      </li>
      <li role="menuitem">
        <a *ngIf="gocamModelCount > 0" class="dropdown-item" title="View pathway coverage" (click)="showPathwayCoverage()">
          View pathway coverage
        </a>
      </li>
      <li *ngIf="gocamModelCount > 0" role="menuitem">
        <a *ngIf="genes.length <= maxMegaModelCoverageGenes" class="dropdown-item" title="View in mega-model" (click)="gotoMegaModel()">
          View coverage in mega-model (up to {{maxMegaModelCoverageGenes}} genes)
        </a>
        <a *ngIf="genes.length > maxMegaModelCoverageGenes" class="dropdown-item disabled-menu-item"
              title="View coverage in mega-model disabled due to too many (>{{maxMegaModelCoverageGenes}}) genes">
          View coverage in mega-model (up to {{maxMegaModelCoverageGenes}} genes)
        </a>
      </li>
    </ul>
  </div>

  <div class="btn-group" dropdown *ngIf="slimNames.length != 0">
    <button id="slim-button" dropdownToggle type="button" class="btn btn-primary dropdown-toggle">
      Slim with:
    </button>

    <ul id="slim-dropdown" *dropdownMenu class="dropdown-menu" role="menu">
      <li *ngFor="let subsetName of slimNames" role="menuitem">
        <a class="dropdown-item" (click)="showSlim(subsetName)">
          {{slimConfig[subsetName].slim_display_name}}
        </a>
      </li>
    </ul>
  </div>

  <div class="action">
      <button [disabled]="genes.length > 1000"
              title="{{genes.length > 1000 ? tooManyGenesTitle : selectGenesTitle}}"
              class="btn btn-primary" (click)="startSelection()">Select subset</button>
  </div>

  <div class="action" *ngIf="!interMineButtonVisible()">
    <button class="btn btn-primary" (click)="download()">Download ...</button>
  </div>

  <div *ngIf="interMineButtonVisible()" class="btn-group" dropdown>
    <button id="slim-button" dropdownToggle type="button" class="btn btn-primary dropdown-toggle">
      Export:
    </button>

    <ul id="export-dropdown" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
      <li role="menuitem">
        <a class="dropdown-item" (click)="download()">
          Download ...
        </a>
      </li>
      <li role="menuitem">
        <a class="dropdown-item" (click)="sendToInterMine()">
          Send to {{intermineConfig!.mine_name}} ...
        </a>
      </li>
    </ul>
  </div>

  </div>

  </div>

  <div *ngIf="showingVisualisation()" class="action">
    <button class="btn btn-primary"
            title="Return to gene list"
            (click)="showResults()">Finish visualisation</button>
  </div>

  <div *ngIf="showingSlim() || showingSubsetCounts()" class="action">
    <button class="btn btn-primary"
            title="Return to gene list"
            (click)="showResults()">Back to results</button>
  </div>
  </div>

  <div class="content">
  <div *ngIf="showingVisualisation()">
    <app-gene-results-vis *ngIf="showingQuilt()" [genes]="genes" [geneListDescription]="queryResultDisplayName(queryResult)">
    </app-gene-results-vis>
    <div *ngIf="showingGeneEx()" class="gene-expression-vis">
      "Violin plots" of available gene expression datasets
      with gene expression levels shown as a red points:
      <img alt="Gene expression view loading ..." [src]="geneExImgSrc()"/>
    </div>
  </div>

  <div *ngIf="showingSubsetCounts() && subsetCountName">
    <app-gene-results-subset-count [genes]="genes" [subsetType]="subsetCountName"
                                   [geneListDescription]="queryResultDisplayName(queryResult)">
    </app-gene-results-subset-count>
  </div>

  <div *ngIf="showingSlim()">
    <app-gene-results-slim-table [genes]="genes" [slimName]="slimName!"
                                 [geneListDescription]="queryResultDisplayName(queryResult)">
    </app-gene-results-slim-table>
  </div>

  <div *ngIf="!showingVisualisation() && !showingSlim() && !showingSubsetCounts()">
  <form>

  <app-loading-spinner *ngIf="loading"></app-loading-spinner>

  <table>
    <thead>
      <tr>
        <th *ngIf="selectionInProgress()">
          &nbsp;
        </th>
        <th *ngFor="let fieldConfig of visibleFields">
            <a *ngIf="orderByFieldName != fieldConfig.name" (click)="setOrderBy(fieldConfig.name)"
               title="Click to sort">{{fieldConfig.display_name}}<img src="assets/sort_both.svg"/></a>
            <span *ngIf="orderByFieldName == fieldConfig.name">{{fieldConfig.display_name}}<img title="Sorted by: {{fieldConfig.display_name}}" src="assets/sort_up.svg"/></span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let gene of sanitizedDisplayGenes">
        <td *ngIf="selectionInProgress()">
          <input type="checkbox"
                 [name]="gene.uniquename"
                 (ngModelChange)="selectionChanged()"
                 [(ngModel)]="selectedGenes![gene.uniquename]"/>
        </td>
        <td *ngFor="let fieldConfig of visibleFields">
          <a *ngIf="fieldConfig.name == 'uniquename'" routerLink="/gene/{{gene['uniquename']}}">
              {{gene['uniquename']}}
          </a>
          <a *ngIf="fieldConfig.name == 'name' && gene.name" routerLink="/gene/{{gene['uniquename']}}">
              {{gene['name']}}
          </a>
          <span *ngIf="fieldConfig.name != 'uniquename' && fieldConfig.name != 'name'" class="td-content">
             <span *ngIf="gene[fieldConfig.name]"
                   [innerHtml]="gene[fieldConfig.name]">
             </span>
             <span class="na-field" *ngIf="!gene[fieldConfig.name] && fieldConfig.column_type === 'expression_level'">
             </span>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
  </form>
  </div>
</div>
</fieldset>

<form #interMineSendForm *ngIf="interMineButtonVisible()" ngNoForm
      class="intermine-send-form" action="{{intermineConfig!.list_post_url}}"
      method="post">
  <input type="hidden" name="class" value="Gene">
  <input #interMineSendFormExtIds type="hidden" name="externalids" value="">
  <input type="submit" value="Submit">
</form>

</div>
